module.exports = __webpack_public_path__ + "img/imgvector.1b9a21b9.jpg";